import React, { useState } from "react";
import { connect } from 'react-redux';

import CommonStyles from "./CommonStyles";
import { withStyles, makeStyles } from '@mui/styles';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';

import ComponentWrapper from "./ComponentWrapper";

import ViewAccessRule from "./ViewAccessRule";
import TrplSelect from "./TrplControls/TrplSelect";

import { getRandomInteger } from "../utils";

const styles = {
  ...CommonStyles,
};

const useStyles = makeStyles({
  container: {
    height: 33,
    fontSize: 12,
    display: 'flex',
    color: '#4C4C4C',
    paddingLeft: 30,
    background: '#fff',
    alignItems: 'center',
    width: 'fit-content',
  },
  icon: {
    fontSize: 20,
    color: '#168CCE',
    marginRight: '5px',
  },
  iconBtn: ({ value }) => ({
    height: 36,
    fontSize: 12,
    display: 'flex',
    color: '#168CCE',
    paddingLeft: 20,
    paddingRight: 20,
    marginLeft: '5px',
    cursor: 'pointer',
    opacity: value === 'none' ? 0.4 : 1,
    pointerEvents: value === 'none' ? 'none' : '',
    width: 'fit-content',
    alignItems: 'center',
    background: '#e8e8f7',
    textTransform: 'capitalize',
    '&:hover': {
      background: '#fff',
    },
  }),
});


const CreateRuleBtn = ({ title, viewsSelectValues, getRulesInitials, createDraftAccessRule }) => {
  const [value, setValue] = useState('none');

  const classes = useStyles({
    value,
  });

  return (
    <div style={{ display: 'flex', margin: '5px' }}>
      <div className={classes.container} >
        <span>{title} &nbsp;</span>

        <div style={{ padding: '5px', width: '320px' }}>
          <TrplSelect
            margin="none"
            complicatedValues
            values={viewsSelectValues}
            onChange={(e) => {
              setValue(e.target.value);
            }}
            value={value}
          />
        </div>
      </div>

      <div className={classes.iconBtn} onClick={() => {
        getRulesInitials(value, createDraftAccessRule);
        setValue('none');
      }}>
        <AddOutlinedIcon className={classes.icon} />
        <span>Add rule</span>
      </div>
    </div>
  );
};


class AccessRulesList extends ComponentWrapper {
  state = {
    loaded: false,
    viewsSelectList: [{ title: 'none', value: 'none' }],
  };

  componentDidMount() {
    this.createViewsSelectList();
  };

  createViewsSelectList = () => {
    const { jels, viewsIds } = this.props;

    const viewsSelectList = [ ...this.state.viewsSelectList ];

    viewsIds.forEach(id => {
      if (jels.jelData[id]) {
        let view = jels.jelData[id];
        viewsSelectList.push({ title: `${view.id} ${view.title}`, value: id });
      }
    });

    this.setState({ viewsSelectList });
  };

  updateAccessRule = (rule, cb) => {
    rule.views.forEach(view => {
      if (view.deletedChains) delete view.deletedChains;
      for (let chain in view.chains) {
        if (view.chains[chain] === '') delete view.chains[chain];
      }
      if (view.chains && !Object.keys(view.chains).length) delete view.chains;
    });

    const cleanedViewsFromRemoved = rule.missingViews && rule.missingViews.length ?
      rule.views.filter(view => !rule.missingViews.includes(view.id)) : rule.views;

    const ruleData = {
      views: cleanedViewsFromRemoved,
      categories: rule.categories,
    };

    if (rule.id) {
      ruleData.id = rule.id;
    }

    if (rule.trigger && rule.trigger.trpls && rule.trigger.trpls.length) {
      ruleData.trigger = rule.trigger;
    }

    this.postWithData({
      url: `/rest/upd_access_rule`,
      data: ruleData,
      cb: (data) => {
        if (data._status === 'ok') {
          if (rule.temporary_id) data.access_rule.temporary_id = rule.temporary_id;
          this.props.updateRuleOnSave(data.access_rule);
          if (cb) cb(data.access_rule);
        }
      }
    });
  };

  getRulesInitials = (viewId, cb) => {
    this.postWithData({
      url: `/rest/get_access_rules_initials`,
      data: { id: viewId },
      cb: (data) => {
        if (cb) cb(data);
      }
    });
  };

  createDraftAccessRule = (data) => {
    const { concept, jels, addRuleToAccessRulesArray } = this.props;

    const newViews = data.views.map(view => {
      const newView = { ...view, default: 'WRITE' }
      return newView;
    });

    const newAccessRule = {
      editable: true,
      views: [...newViews],
      categories: [concept.id],
      trigger: {
        ancestor: jels.jelData[data.views[0].id].concept
      },
      temporary_id: `${getRandomInteger(10000, 90000)}_${data.views[0].id}`,
    };

    addRuleToAccessRulesArray(newAccessRule);
  };

  render() {
    const { classes, jels, setup_rbox_light, deleteAccessRule, accessRules, accessRulesNodes, addNodeToNodesData } = this.props;
    const { viewsSelectList } = this.state;

    return (
      <div className={`${classes.m10}`} >
        <CreateRuleBtn
          title='Create new Access Rule to view:'
          viewsSelectValues={viewsSelectList}
          getRulesInitials={this.getRulesInitials}
          createDraftAccessRule={this.createDraftAccessRule}
          getUserViewAccessDataList={this.getUserViewAccessDataList}
        />
        {accessRules.length ? accessRules.map((rule, index)=> {
          const indentificator = rule.temporary_id ? 'temporary_id' : 'id';
          return (
            <ViewAccessRule
              updateAccessRule={this.updateAccessRule}
              getRulesInitials={this.getRulesInitials}
              addNodeToNodesData={addNodeToNodesData}
              accessRulesNodes={accessRulesNodes}
              deleteAccessRule={deleteAccessRule}
              setup_tbox={setup_rbox_light}
              key={rule[indentificator]}
              modifiable={true}
              ruleIndex={index}
              ruleData={rule}
              jels={jels}
            />
          )
        }) : <div className={`${classes.justifyCenter} ${classes.m20}`} style={{ color: '#C4C4C4' }}>No access rules created in this dashboard</div>
        }
      </div>
    )
  }
}

export default connect((state) => ({
  jels: state.jels,
  setup: state.meta.setup,
  accounts_tbox: state.meta.accounts_tbox,
  setup_rbox_light: state.meta.light_meta_and_ops.setup_rbox_light,
 }),
{ })(withStyles(styles)(AccessRulesList));
